import React from 'react'
import PropTypes from 'prop-types'

const icons = {
  manExplode: '/catalogo/images/man-explode.png',
  computerWalestore: '/catalogo/images/computer-walestore.png',
}

const sizeDefinition = {
  60: [60, 60],
}
const Icon = ({ name, size }) => (
  <img
    className="bs__icon"
    height={sizeDefinition[size][0]}
    width={sizeDefinition[size][1]}
    alt={name}
    src={icons[name]}
  />
)

Icon.defaultProps = {
  size: 60,
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
}

export default Icon
